/**
 * Conversation Hash Management
 * Manages conversation ID in URL hash for deep linking
 */

export const getConversationFromHash = () => {
  const hash = window.location.hash;
  if (hash.startsWith('#chat=')) {
    return hash.replace('#chat=', '');
  }
  return null;
};

export const setConversationInHash = (conversationId) => {
  window.location.hash = `chat=${conversationId}`;
};

export const clearChatFromHash = () => {
  if (window.location.hash.startsWith('#chat=')) {
    window.location.hash = '';
  }
};

/**
 * Empty Conversation Tracking
 * Tracks empty conversations in localStorage for reuse
 */

export const markConversationAsEmpty = (conversationId) => {
  localStorage.setItem('chat_emptyConversation', conversationId);
};

export const getEmptyConversationFromStorage = () => {
  return localStorage.getItem('chat_emptyConversation');
};

export const clearEmptyConversationFlag = () => {
  localStorage.removeItem('chat_emptyConversation');
};

